export interface StructuredRecordLike {
  type?: string | null;
  structure_type?: string | null;
  is_main_record?: boolean | string | null;
}

function isMainFlag(value: StructuredRecordLike["is_main_record"]): boolean {
  return value === true || value === "true";
}

export function isMainStructuredRecord(record: StructuredRecordLike | null | undefined): boolean {
  return isMainFlag(record?.is_main_record);
}

export function isAnthropometryStructuredRecord(record: StructuredRecordLike | null | undefined): boolean {
  if (!record?.type) return false;
  if (record.type === "anthropometry") return true;
  if (record.type === "anamnesis" && record.structure_type === "antropometry") return true;
  if (record.type === "physiotherapy_evolution" && record.structure_type === "antropometry") return true;
  if (record.type === "body_measurement") return true;
  return false;
}

export function isMedicalReportStructuredRecord(record: StructuredRecordLike | null | undefined): boolean {
  return record?.type === "medical_report";
}

export function isClinicalStructuredRecord(record: StructuredRecordLike | null | undefined): boolean {
  if (!record?.type) return false;

  if (record.type === "clinical_record") return true;
  if (record.type === "clinical_note") return true;
  if (record.type === "exam") return true;
  if (record.type === "report") return true;

  if (record.type === "anamnesis") {
    return !record.structure_type || record.structure_type === "anamnesis";
  }

  return false;
}

export function isClinicalStructuredRecordIncludingMain(record: StructuredRecordLike | null | undefined): boolean {
  return isClinicalStructuredRecord(record);
}
